import { render } from "./CourseHorizontalScrollView.vue?vue&type=template&id=439f86f4&scoped=true"
import script from "./CourseHorizontalScrollView.vue?vue&type=script&lang=js"
export * from "./CourseHorizontalScrollView.vue?vue&type=script&lang=js"

import "./CourseHorizontalScrollView.vue?vue&type=style&index=0&id=439f86f4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-439f86f4"]])

export default __exports__